import {useMemo} from "react";

export const useClassNames = (...args: (string | undefined | null | false)[]) => {
  return useMemo(() => {
    return args.filter((v) => !!v).join(' ')
  }, [args])
}
